import React, { useState, Children, isValidElement, cloneElement } from 'react';
import {
  Button,
  TableCell,
  TableRow,
} from '@mui/material';
import { ArrowDownward } from '@mui/icons-material';

const T_TitleCell = ({
  text = '',
  bol = true,
  onClick = () => {},
  fontSize = 15,
  arrow = false,
  color = 'rgba(0, 0, 0, 0.87)',
  overColor = 'rgba(0, 0, 0, 0.6)',
  backgroundColor = 'transparent',
  overBackgroundColor = 'rgba(0,0,0,0.1)',
  style = {},
  justifyContent = 'center',
  ...other
}) => {
  const [over, setOver] = useState(false);
  const arrow_over = over && arrow;
  return (
    <TableCell
      style={{
        backgroundColor: arrow_over ? overBackgroundColor : backgroundColor,
        cursor: arrow ? 'pointer' : 'default',
        ...style,
      }}
      align='center'
      onClick={arrow ? onClick : () => {}}
      onMouseOver={() => setOver(true)}
      onMouseOut={() => setOver(false)}
      {...other}
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent,
        color: arrow_over ? overColor : color,
        fontSize,
        fontWeight: 700,
      }}
      >
        {text}
        {arrow && (
          <ArrowDownward style={{
            transition: 'transform 200ms',
            fontSize,
            marginLeft: 4,
            marginRight: 4,
            transform: bol ? 'rotate(0deg)' : 'rotate(180deg)',
          }}
          />
        )}
      </div>
    </TableCell>
  );
};

const T_Btn_Function = ({ width = 66, color = 'white', backgroundColor = '#000000', text = '', onClick = () => {}, disabled = false, style = {} }) => {
  const [over, setOver] = useState(false);
  return (
    <Button
      disabled={disabled}
      style={{
        width,
        borderRadius: 8,
        height: 32,
        backgroundColor: disabled ? 'gray' : backgroundColor + (over ? '80' : ''),
        color: disabled ? '#d8d8d8' : color,
        fontSize: 16,
        boxShadow: '0px 6px 10px -2px rgba(67, 67, 75, 0.2)',
        transition: 'none',
        ...style,
      }}
      onClick={onClick}
      onMouseOver={() => setOver(true)}
      onMouseOut={() => setOver(false)}
    >
      {text}
    </Button>
  );
};

const T_TableRow = ({
  children = null,
  backgroundColor = 'transparent',
  overBackgroundColor = 'rgba(0,0,0,0.2)',
  disOver = false,
}) => {
  const [over, setOver] = useState(false);
  return (
    <TableRow
      style={{ height: 40, backgroundColor: (over && !disOver) ? overBackgroundColor : backgroundColor }}
      onMouseOver={() => setOver(true)}
      onMouseOut={() => setOver(false)}
    >
      {Children.map(children, child => {
        const style = { ...(child?.props?.style || {}) };
        if (over && !disOver) style.backgroundColor = 'transparent';
        if (!isValidElement(child)) return null;
        return cloneElement(child, {
          ...child.props,
          style,
        });
      })}
      {/* {children} */}
    </TableRow>
  );
};

export { T_TitleCell, T_Btn_Function, T_TableRow };
